<template>
  <div>
    <div>
      <video
        v-bind="$attrs"
        v-on="$listeners"
        ref="videoPlayer"
        class="video_player__class"
        controlsList="nodownload"
        disablepictureinpicture
        preload="auto"
        :poster="video.thumbnail ? video.thumbnail.file : ''"
        @play="watchingAtPlay"
        @timeupdate="watching"
        @contextmenu="disbleRightClick($event)"
      >
        <source v-if="Object.keys(video).length !== 0" :src="video.video.file" />
        <!-- <source v-for="(item, i) in value" :key="i" :src="item.video.file" /> -->
      </video>
    </div>
  </div>
</template>
<script>
import helper from "@/helper/index";
import Axios from "@/api/newAxios";
import apiUrl from "@/common/apiUrl";
import commonFunctions from "@/common/commonFunctions";
export default {
  name: "VideoPlayer",
  props: {
    // value: {
    //   type: Array,
    //   required: false,
    // },
    video: {
      type: Object,
      required: false,
    },
    playing_list: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      watched: false,
      player: null,
      options: {
        controls: true,
        autoplay: false,
        sources: [],
      },
    };
  },
  computed: {
    user_id() {
      return this.$route.query.usid;
    },
    is_same_user() {
      return helper.isSameUser(this.user_id);
    },
  },
  watch: {},
  methods: {
    endedVideo() {
      console.log("video ended");
    },
    disbleRightClick(event) {
      event.preventDefault();

      // console.log(event, "event");
    },
    watching() {
      let current_time = this.$refs.videoPlayer.currentTime;
      let duration = this.$refs.videoPlayer.duration;
      let playPercent = Math.round(
        (parseFloat(current_time) / parseFloat(duration)) * 100
      );
      if (playPercent == 20 || playPercent == 30 || playPercent == 50) {
        if (!this.is_same_user) {
          // console.log("capture view");
          this.captureView();
        }
      }
      // console.log("watching", current_time, duration, playPercent);
    },
    watchingAtPlay() {
      if (!this.is_same_user) {
        // console.log("capture view");
        this.captureView();
      }
    },
    captureView() {
      const onSuccess = () => {};
      const onFailure = () => {};

      let data = {};
      data["video"] = this.video.id;
      data["profile"] = commonFunctions.getProfileId();
      Axios("post", apiUrl.CAPTURE_VIEWS, {
        data,
        onSuccess,
        onFailure,
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.video_player__class {
  border-radius: 20px !important;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: contain;
}
@media all and (max-width: 600px) {
  .video_player__class {
    border-radius: 0px !important;
  }
}
</style>
